import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { RolePermissionGuard } from "./role.permission.guard";
import { AuthenticationService } from "../../services/api/authentication.service";

@Injectable()
export class ViewDataTransferPermissionGuard extends RolePermissionGuard {
  constructor(
    override applicationUserService: AuthenticationService,
    override router: Router
  ) {
    super(
      applicationUserService,
      router,
      ["Administrator", "Service", "Sales", "InternalSales", "Customer"],
      "/portal/home"
    );
  }
}
